import component from "./index";
import DesignTool from "./DesignTool";
import { addTabPane, deleteTabPane } from './actions';
const makeEmptyTabs = count => Array.from({
  length: count
}, (_, index) => ({
  type: 'w-tab-pane',
  props: {
    title: `未命名页卡${index + 1}`
  }
}));

/** @type {UICore.ComponentMeta} */
const TabsComponentMeta = {
  id: 'w-tabs',
  name: '选项卡',
  icon: 'https://vfiles.gtimg.cn/wuji_dashboard/xy/rainbow/icon-tabs_1636365338540.png',
  category: '布局',
  component,
  slots: [{
    id: 'default',
    frozen: true,
    allowDeleteChildren: true
  }],
  bindings: [{
    id: '选中序号',
    prop: 'cur',
    event: 'select'
  }],
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'cur',
      type: 'number',
      title: '当前选中序号',
      default: 0
    }, {
      id: 'titleCss',
      type: 'string',
      title: '头部样式',
      default: '',
      ui: {
        settings: {
          multipleLine: true
        }
      }
    }]
  },
  events: [{
    id: 'select',
    name: '切换页卡',
    desc: '切换时触发，$event 为页卡序号(0开始)'
  }],
  designTool: DesignTool,
  propPanel: {
    main: 'UcTabsPropPanel'
  },
  presets: [{
    name: '选项卡',
    layout: {
      props: {},
      children: [{
        type: 'w-tab-pane',
        props: {
          title: '未命名页卡1'
        }
      }, {
        type: 'w-tab-pane',
        props: {
          title: '未命名页卡2'
        }
      }]
    }
  }],
  report: {
    selfReport: true,
    events: [{
      id: 'select',
      eidPlaceholder: '默认取页卡名称作为上报标识'
    }]
  },
  getActions({
    modifyComp,
    instance
  }) {
    return [{
      title: '添加页卡',
      icon: 'fa fa-plus',
      place: ['actionBar', 'contextMenu'],
      execute: () => modifyComp(c => addTabPane(c))
    }, {
      title: '删除页卡',
      icon: 'fa fa-minus',
      place: ['actionBar', 'contextMenu'],
      execute: () => modifyComp(c => deleteTabPane(c, instance.current))
    }];
  },
  placeCompInside(ctx) {
    const getLayout = content => {
      const layoutContainer = {
        type: this.id,
        children: makeEmptyTabs(2)
      };
      // 演示一下如何拿被装入组件的meta
      if (ctx.meta.display === 'inline') {
        layoutContainer.children[0].children = [{
          type: 'w-paragraph',
          children: content
        }];
      } else {
        layoutContainer.children[0].children = content;
      }
      return layoutContainer;
    };
    return {
      name: this.name,
      /** 组件图标  */
      icon: this.icon,
      getLayout
    };
  }
};
export default TabsComponentMeta;
//# sourceMappingURL=meta.js.map
